var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css, keyframes } from "styled-components";
import { error as errorColour } from "@irati/ui/src/global/colors";
import { FIXED_HEIGHT_WRAPPER_TROPHY_SELECTED, FIXED_HEIGHT_WRAPPER_TROPHY_NOT_SELECTED } from "../constants";
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-shadow: 0 0 0 1px ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  border-radius: 2px;\n  height: ", ";\n  width: 100%;\n  ", "\n"], ["\n  box-shadow: 0 0 0 1px ", ";\n  margin-top: ", ";\n  margin-bottom: ", ";\n  border-radius: 2px;\n  height: ", ";\n  width: 100%;\n  ",
    "\n"])), function (_a) {
    var error = _a.error;
    return (error ? errorColour : "rgba(61,61,54,0.25)");
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.one;
}, function (_a) {
    var theme = _a.theme, error = _a.error;
    return (error ? theme.spacing.two : "0");
}, function (_a) {
    var isTrophySelected = _a.isTrophySelected;
    return (isTrophySelected ? FIXED_HEIGHT_WRAPPER_TROPHY_SELECTED : FIXED_HEIGHT_WRAPPER_TROPHY_NOT_SELECTED);
}, function (_a) {
    var isTrophySelected = _a.isTrophySelected;
    return isTrophySelected && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      animation: ", " 1.2s ease;\n    "], ["\n      animation: ",
        " 1.2s ease;\n    "])), keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      0% {\n        overflow: hidden;\n      }\n      100% {\n        overflow: visible;\n      }\n    "], ["\n      0% {\n        overflow: hidden;\n      }\n      100% {\n        overflow: visible;\n      }\n    "]))));
});
export default Wrapper;
var templateObject_1, templateObject_2, templateObject_3;
